import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'David M.',
  location: 'Glasgow West End',
  text: 'Brilliant service. Boiler broke down on a freezing Sunday morning, they were here within 2 hours and had it fixed. Highly recommend.'
}, {
  name: 'Sarah T.',
  location: 'Paisley',
  text: 'Got a new combi boiler installed. The guys were polite, tidy, and explained everything clearly. Price was exactly as quoted.'
}, {
  name: 'James C.',
  location: 'Clydebank',
  text: 'Been using Clydeside for my annual landlord gas safety checks for years. Always reliable and easy to deal with.'
}];
export function Testimonials() {
  return <section className="py-24 relative z-10 bg-[#0a0a0a] border-t border-white/5" data-id="element-249">
      <div className="max-w-7xl mx-auto px-6" data-id="element-250">
        <div className="text-center mb-16" data-id="element-251">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-white" data-id="element-252">
            What Our Customers Say
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-253">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-card p-8 rounded-2xl border border-white/5 relative hover:border-[#FF9500]/20 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_10px_30px_-15px_rgba(255,149,0,0.1)]" data-id="element-254">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-white/5" data-id="element-255" />
              <div className="flex items-center gap-1 mb-6" data-id="element-256">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#FFD600] text-[#FFD600]" data-id="element-257" />)}
              </div>
              <p className="text-gray-300 mb-8 leading-relaxed relative z-10" data-id="element-258">
                "{testimonial.text}"
              </p>
              <div data-id="element-259">
                <div className="font-bold text-white" data-id="element-260">{testimonial.name}</div>
                <div className="text-sm text-gray-500" data-id="element-261">
                  {testimonial.location}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}